<template>
    <div :class="singleItemClass" @click="emitEvent({ name: 'make-referral', payload: item })">
        <div class="search-results">
            <div v-if="item.type !== 'typed'" class="avatar-container">
                <img :src="returnAvatar" />
            </div>
            <div class="user-info-container">
                <span v-if="item && item.type === 'user'">
                    <p>
                        <span>
                            {{ item.name }}
                            <span v-if="item.designation">, {{ item.designation }}</span>
                        </span>
                        <span v-if="item.specialities && item.specialities.length > 0 && item.specialities[0].speciality">
                            <span class="user-info-description">
                                {{ item.specialities[0]['speciality']['name'] }}
                            </span>
                        </span>
                    </p>
                    <p>
                        <span>{{ item?.practice?.name }}</span>
                        <span v-if="item.type !== 'typed'" class="user-info-description">
                            {{ userInfoDescription(item) }}
                        </span>
                    </p>
                </span>
                <span v-else>
                    <p>
                        <span>{{ item.name }}</span>
                        <span v-if="item.type !== 'typed'" class="user-info-description">
                            {{ userInfoDescription(item) }}
                        </span>
                    </p>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import PracticePlanEnum from '@/enums/PracticePlanEnum'

    export default {
        props: {
            item: { type: Object, required: true },
            disableNetworkPlan: { type: Boolean, default: false },
        },

        data() {
            return {
                userId: null,
                queryParams: {},
            }
        },

        computed: {
            returnAvatar() {
                if (this.item?.type === 'user') {
                    if (this.item?.avatar && this.item.avatar['thumb-360']) return this.item.avatar['thumb-360']
                } else {
                    if (this.item?.image && this.item.image['thumb-360']) return this.item.image['thumb-360']
                }
                return require('./../../../../src/images/avatar-placeholder.png')
            },

            calculateInitials() {
                let nameSplit = this.item.name.split(' ')
                let initials = ''

                for (let i = 0; i < nameSplit.length; i++) {
                    initials += nameSplit[i][0]
                }

                return initials
            },

            isDisabled() {
                return this.disableNetworkPlan && this.item.subscription === PracticePlanEnum.NETWORK
            },

            singleItemClass() {
                return {
                    'search-autocomplete__single-item': true,
                    'search-autocomplete__single-item--disabled': this.isDisabled,
                }
            },

            userid() {
                return this.userId
            },

            returnQueryParams() {
                return this.queryParams
            },
        },
        methods: {
            userInfoDescription(item) {
                if (this.item?.type === 'user') {
                    return `${item?.practice?.address}, ${item?.practice?.city} (${item?.practice?.state})`
                } else {
                    return `${item?.address}, ${item?.city} (${item?.state})`
                }
            },
        },
    }
</script>
